import { routeArr } from '@/router'
import { getRouters } from '@/api/login'
import Layout from '@/layout/index'
import store from '@/store'
// import ParentView from '@/components/ParentView/index'

const route = {
    state: {
        // 所有的路由
        routes: [],
        // 动态新增的路由
        addRoutes: [],
        // 侧边导航栏需要的路由
        sidebarRouters: []
    },
    mutations: {
        SET_ROUTES: (state, routes) => {
            state.addRoutes = routes
            state.routes = routeArr.concat(routes)
            state.sidebarRouters = routeArr.concat(routes)
        },
    },
    actions: {
        // 生成路由
        GenerateRoutes({ commit }) {
            return new Promise(resolve => {
                // 向后端请求路由数据
                getRouters().then(res => {
                    const routerJson = JSON.parse(JSON.stringify(res.data))
                    const routers = filterRouter(routerJson)
                    // 劳动合同模块按角色控制可见子页面
                    const roles = store.getters.roles || []
                    // ifZjl：后端按系统约定(SecurityUtils.ifZjl)计算的总经理标志，兼容 roleKey=zjl
                    const ifZjl = store.state.user.ifZjl === 1 || store.state.user.ifZjl === '1'
                    const ctx = {
                        // 行政(roleKey=xz) 与 超级管理员(roleKey=admin) 拥有模块全部内容
                        isAdmin: roles.includes('xz') || roles.includes('admin'),
                        // 总经理：优先用后端 ifZjl 标志，兼容 roleKey=zjl
                        isZjl: ifZjl || roles.includes('zjl'),
                        // 其他角色：非行政且非总经理
                        isOther: !(roles.includes('xz') || roles.includes('admin')) && !ifZjl && !roles.includes('zjl')
                    }
                    applyLaborMenuFilter(routers, ctx)
                    routers.push({ path: '*', redirect: '/404', hidden: true })
                    commit('SET_ROUTES', routers)
                    resolve(routers)
                })
            })
        }
    }
}

/**
 * 劳动合同模块菜单可见性：
 *   行政(roleKey=xz) 与 超级管理员(roleKey=admin) -> 全部页面
 *   总经理(ifZjl 标志 / roleKey=zjl)             -> 概览看板 + 到期提醒
 *   其他角色                                    -> 合同管理 + 到期提醒
 * 后端已将模块菜单授予所有角色，这里只做前端展示层的隐藏。
 */
function applyLaborMenuFilter(routers, ctx) {
    routers.forEach(route => {
        if (route.children && route.children.length) {
            const hasLabor = route.children.some(c => (c.path || '').startsWith('laborContract/'))
            applyLaborMenuFilter(route.children, ctx)
            route.children = route.children.filter(child => {
                const p = child.path || ''
                if (!p.startsWith('laborContract/')) return true
                if (p === 'laborContract/dashboard') return ctx.isAdmin || ctx.isZjl
                if (p === 'laborContract/contracts') return ctx.isAdmin || ctx.isOther
                if (p === 'laborContract/remind') return true
                if (p === 'laborContract/employees') return ctx.isAdmin
                if (p === 'laborContract/settings') return ctx.isAdmin
                if (p === 'laborContract/auditContract') return true
                return true
            })
            if (hasLabor && route.children.length === 0) {
                route._laborRemove = true
            }
        }
    })
    for (let i = routers.length - 1; i >= 0; i--) {
        if (routers[i]._laborRemove) routers.splice(i, 1)
    }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterRouter(routerMap) {
    return routerMap.filter(route => {
        if (route.component) {
            if(!route.path || route.path==='/null' || route.path==='null'){
                route.path = "";
            }
            if (route.component === 'layout') {
                route.component = Layout
            } else if(route.component === 'parentView'){
                route.component = ParentView
            } else {
                route.component = loadView(route.component)
            }
        }
        if (route.children != null && route.children && route.children.length) {
            route.children = filterRouter(route.children)
        }
        return true
    })
}

export const loadView = (view) => { // 路由懒加载
    return (resolve) => require([`@/views/${view}`], resolve)
}

export default route
